export function CsvDownloader<T>(data: T[], fields: (keyof T)[], fileName: string) {
  const downloadCSV = () => {
    if (!data.length || !fields.length) return

    const header = fields.map((f) => String(f).toUpperCase()).join(',')
    const dateFields = ['employmentDate', 'terminationDate'].map((f) => f.toLowerCase())

    const rows = data.map((item) =>
      fields
        .map((field) => {
          const rawVal = item[field]

          let strVal: string

          if (rawVal == null) {
            strVal = ''
          } else if (String(field).toLowerCase() === 'msisdn') {
            strVal = `="${String(rawVal)}"`
          } else if (dateFields.includes(String(field).toLowerCase())) {
            strVal = `="${String(rawVal)}"`
          } else {
            strVal = String(rawVal)
          }

          const csvSafeValue = `"${strVal.replace(/"/g, '""')}"`
          return csvSafeValue
        })
        .join(','),
    )

    const csvContent = [header, ...rows].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    link.click()

    URL.revokeObjectURL(url)
  }

  return downloadCSV
}
